<section class="fr-detail">
  <app-admin-page-header>
    <ng-container description>
      <a routerLink="/platform/feature-requests" class="cg-admin-link">← Back to Feature Requests</a>
    </ng-container>
    <ng-container actions>
      @if (showDelete() && request()) {
        <app-admin-button variant="danger" type="button" (click)="deleteRequest()" [disabled]="!canDelete()">
          Delete
        </app-admin-button>
      }
    </ng-container>
  </app-admin-page-header>

  @if (loading()) {
    <p class="cg-form-help">Loading…</p>
  } @else if (error()) {
    <div class="cg-admin-alert cg-admin-alert--error">{{ error() }}</div>
  } @else if (request(); as req) {
    <div class="fr-detail__grid">
      <app-admin-card title="Information" icon="inbox">
        <dl class="fr-detail__meta">
          <div><dt>Request ID</dt><dd><code>{{ req.requestNumber }}</code></dd></div>
          <div><dt>Title</dt><dd>{{ req.title }}</dd></div>
          <div><dt>Type</dt><dd>{{ typeLabels[req.type] }}</dd></div>
          <div><dt>Priority</dt><dd><app-feature-request-priority-badge [priority]="req.priority" /></dd></div>
          <div><dt>Status</dt><dd><app-feature-request-status-badge [status]="req.status" /></dd></div>
          <div><dt>Created By</dt><dd>{{ req.createdByUser?.displayName ?? req.createdBy }}</dd></div>
          <div><dt>Assigned To</dt><dd>{{ req.assignedToUser?.displayName ?? '—' }}</dd></div>
          <div><dt>Created Date</dt><dd>{{ req.createdAt | date: 'medium' }}</dd></div>
          <div><dt>Last Updated</dt><dd>{{ req.updatedAt | date: 'medium' }}</dd></div>
        </dl>

        @if (showAdminControls()) {
          <div class="fr-detail__admin">
            @if (showStatusChange()) {
            <label class="cg-admin-field">
              <span class="cg-admin-field__label">Status</span>
              <select
                class="cg-select"
                [ngModel]="req.status"
                (ngModelChange)="onStatusChange(req, $event)"
                [disabled]="!canStatusChange() || statusSaving()"
                name="fr-detail-status"
              >
                @for (st of statuses; track st) {
                  <option [value]="st">{{ statusLabels[st] }}</option>
                }
              </select>
            </label>
            }
            @if (showAssign()) {
            <label class="cg-admin-field">
              <span class="cg-admin-field__label">Assign To</span>
              <select class="cg-select" [(ngModel)]="assignTo" [disabled]="!canAssign() || assignSaving()" (ngModelChange)="onAssignChange()" name="assignTo">
                <option value="">Unassigned</option>
                @for (u of assignableUsers(); track u.userId) {
                  <option [value]="u.userId">{{ u.name }}</option>
                }
              </select>
            </label>
            }
          </div>
        }
      </app-admin-card>

      <app-admin-card title="Description" icon="file-text">
        <p class="fr-detail__description">{{ req.description }}</p>
      </app-admin-card>

      <app-admin-card title="Attachments" icon="image">
        <app-feature-request-attachments-card [requestId]="req._id" />
      </app-admin-card>

      <app-admin-card title="Comments" icon="message-circle">
        <app-feature-request-comments-card
          [requestId]="req._id"
          [currentUserId]="currentUserId()"
          [isAdmin]="showAdminControls()"
          (changed)="onCommentsChanged()"
        />
      </app-admin-card>

      <app-admin-card title="Activity Timeline" icon="clock">
        <app-feature-request-activity-timeline [requestId]="req._id" />
      </app-admin-card>
    </div>
  }
</section>
